<!-- eslint-disable vue/no-v-for-template-key-on-child -->
<template>
  <v-btn
    v-bind="filteredProps"
    :class="[baseClasses, variantClasses]"
    :style="{ '--v-hover-opacity': 0 }"
    :variant="vBtnVariant"
  >
    <template v-for="(_, slot) of $slots" v-slot:[slot]="scope">
      <slot :key="slot" :name="slot" v-bind="scope" />
    </template>
  </v-btn>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { VBtn } from 'vuetify/components'

export type PolarButtonVariant = 'filled' | 'outline' | 'ghost'
export type PolarButtonColor = 'negative'

const CUSTOM_PROPS = ['polarVariant', 'polarColor']

const BASE_CLASSES = [
  'normal-case !rounded font-semibold text-sm tracking-normal',
  '[&_.v-icon]:!text-inherit [&_.v-icon_svg]:!fill-current'
].join(' ')

const VARIANT_CLASSES: Record<PolarButtonVariant, string> = {
  filled: [
    '!bg-negative !text-white',
    'hover:!bg-[#e76f75] active:!bg-[#a01118]',
    'disabled:!bg-negative disabled:!text-white disabled:!opacity-40'
  ].join(' '),
  outline: [
    '!bg-white !border-2 !border-solid !border-negative !text-negative',
    'hover:!bg-[#fef2f2] active:!bg-[#fee2e2]',
    'disabled:!bg-white disabled:!border-negative disabled:!text-negative disabled:!opacity-40'
  ].join(' '),
  ghost: [
    '!bg-transparent !text-negative',
    'hover:!bg-[#fef2f2] active:!bg-[#fee2e2]',
    'disabled:!bg-transparent disabled:!text-negative disabled:!opacity-40'
  ].join(' ')
}

export default defineComponent({
  extends: VBtn,
  inheritAttrs: false,
  props: {
    polarVariant: { type: String as () => PolarButtonVariant, default: 'filled' },
    polarColor: { type: String as () => PolarButtonColor, default: 'negative' }
  },
  computed: {
    filteredProps() {
      const merged = { ...this.$props, ...this.$attrs }
      for (const key of CUSTOM_PROPS) {
        delete merged[key]
      }
      return merged
    },
    baseClasses(): string {
      return BASE_CLASSES
    },
    variantClasses(): string {
      return VARIANT_CLASSES[this.polarVariant]
    },
    vBtnVariant(): string {
      const map: Record<PolarButtonVariant, string> = {
        filled: 'flat',
        outline: 'outlined',
        ghost: 'text'
      }
      return map[this.polarVariant]
    }
  }
})
</script>
